import SecurityRoutes, { SECURITY_BASE_ROUTES } from './SecurityRoutes';

export { SecurityRoutes, SECURITY_BASE_ROUTES };
